import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import React from 'react'
import { observer } from 'mobx-react'
import { cartMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

const BoxPriceModal: React.FC<IProps> = (props) => {
  const BoxPrice = (cartItem: IViewCartItem) => (
    <div className='bpm-item'>
      <span>
        <strong>{cartItem.name}</strong>
        {cartItem.scaleName && (<div>{cartItem.scaleName}</div>)}
      </span>
      <span>{!!cartItem.unitBoxPrice && i18n.t('newCart.boxPricePer', { value: format.toPrice(cartItem.unitBoxPrice) })}</span>
      <span>{!!cartItem.cnt && `x${cartItem.cnt}`}</span>
      <span>{format.toPrice(cartItem.totalBoxPrice)}</span>
    </div>
  )

  const handleClose = () => {
    props.reject()
  }

  return (
    <IonModal
      cssClass='box-price-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='bpm-title'>{i18n.t('newCart.boxPriceExplain')}</div>
      </IonHeader>
      <IonContent className='bpm-content'>
        <div className='bpm-list'>
          {cartMobx.boxPriceCartItems.map(item => (
            <BoxPrice key={item.pk} {...item} />
          ))}
        </div>
      </IonContent>
      <IonFooter className='bpm-footer'>
        <button className='default-btn' data-cypid='boxPriceModalClose' onClick={handleClose}>
          {i18n.t('common.back')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(BoxPriceModal)
